import {
  getEnv,
  getRegion,
  getAccOrigin,
  isGovPartition,
} from '@adsk/acs-sc-web-platform-api';

export function getExoSkeletonRemotesUrl() {
  const env = getEnv();
  const region = getRegion();
  // eslint-disable-next-line @adsk/r13n-best-practices/no-region-string-literal
  const remotesRegion = ['EMEA', 'APAC', 'AUS'].includes(region)
    ? region
    : 'US'; // eslint-disable-line @adsk/r13n-best-practices/no-region-string-literal
  const partitionPrefix = isGovPartition() ? 'govcloud.' : '';

  return `${getAccOrigin({ region: remotesRegion })}/assets/exo/remotes/remotes.${partitionPrefix}${env.toLowerCase()}.${remotesRegion.toLowerCase()}.json`;
}
